import { CACHE_REVALIDATE_5_MIN_MS } from "@nimble/react-requests/api-clients/caching-strategy";
import { useQuery } from "@tanstack/react-query";

import coreApiClient from "@/lib/api-clients/core-api-client";

export function getUseApiUserDiscoverInfoQueryKey() {
  return ["api-user-discover-info"] as const;
}

type UseApiUserDiscoverInfoOptions = {
  enabled: boolean;
};

export function useApiUserDiscoverInfo(options: UseApiUserDiscoverInfoOptions) {
  return useQuery({
    queryKey: getUseApiUserDiscoverInfoQueryKey(),
    queryFn: async () => {
      const { data } = await coreApiClient.getApiUserDiscoverInfo();
      return data;
    },
    staleTime: CACHE_REVALIDATE_5_MIN_MS,
    ...options,
  });
}
